<template>
  <span>{{ animatedNumber }}</span>
</template>

<script>
import anime from 'animejs';
import _ from 'lodash';

export default {
  name: 'AnimatedNumber',
  props: {
    value: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 0.5,
    },
    formatter: Function,
  },
  data() {
    return {
      tweenedNumber: 0,
      NaN: false,
    };
  },
  created() {
    this.markNaN(this.value);
    if (!this.NaN) {
      this.tweenedNumber = this.value;
    }
  },
  computed: {
    animatedNumber() {
      if (this.NaN) {
        return 'NaN';
      }
      return this.formatter ? this.formatter(this.tweenedNumber) : this.tweenedNumber.toFixed(0);
    },
  },
  methods: {
    markNaN(value) {
      if (!_.isNumber(value) || _.isNaN(value)) {
        this.NaN = true;
        return;
      }
      this.NaN = false;
    },
  },
  watch: {
    value(newValue) {
      this.markNaN(newValue);
      if (!this.NaN) {
        anime({ targets: this.$data, duration: this.duration * 1000, tweenedNumber: newValue, easing: 'linear' });
      }
    },
  },
};
</script>
